import type { Theme } from "./semantic/types";

/**
 * Large shell / hero gradient: Learn & Meta use primary; Sri Chaitanya uses secondary (design).
 */
export function getMainScreenChromeGradient(
  theme: Theme,
): readonly [string, string] {
  // if (theme.name === "sriChaitanya") {
  //   return [theme.colors.secondary[50], theme.colors.secondary[20]];
  // }
  return [theme.colors.primary[50], theme.colors.primary[20]];
}
